"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainBase = void 0;
const protocol_1 = require("@prophouse/protocol");
const starknet_1 = require("starknet");
const providers_1 = require("@ethersproject/providers");
const wallet_1 = require("@ethersproject/wallet");
class ChainBase {
    /**
     * A default EVM provider for the chain
     */
    get defaultProvider() {
        if (!this._defaultProvider) {
            this._defaultProvider = new providers_1.JsonRpcProvider(ChainBase.DEFAULT_EVM_RPC[this._evmChainId]);
        }
        return this._defaultProvider;
    }
    /**
     * The EVM provider that was provided via the config
     */
    get provider() {
        if (this._evm.provider) {
            return this._evm.provider;
        }
        return this._evm;
    }
    /**
     * The EVM signer that was provided via the config
     */
    get signer() {
        if (wallet_1.Wallet.isSigner(this._evm)) {
            // Make the assumption that the signer has support for
            // typed data signing to reduce the need for consumers
            // of this class to have to cast.
            return this._evm;
        }
        if (this._evm instanceof providers_1.Web3Provider) {
            return this._evm.getSigner();
        }
        throw new Error('EVM signer not available');
    }
    /**
     * @param config The chain configuration
     */
    // prettier-ignore
    constructor(config) {
        this._evmChainId = config.evmChainId;
        this._addresses = (0, protocol_1.getContractAddressesForChainOrThrow)(config.evmChainId);
        this._evm = this.toEVMSignerOrProvider(config.evm);
        this._defaultProvider = new providers_1.JsonRpcProvider(ChainBase.DEFAULT_EVM_RPC[config.evmChainId]);
        this._starknet = config.starknet instanceof starknet_1.RpcProvider ? config.starknet : new starknet_1.RpcProvider(config.starknet ?? {
            nodeUrl: ChainBase.EVM_TO_DEFAULT_STARKNET_RPC[config.evmChainId],
        });
    }
    /**
     * Convert the provided EVM config value to a signer or provider
     * @param evm The provided evm config value
     */
    toEVMSignerOrProvider(evm) {
        return typeof evm === 'string' ? new providers_1.JsonRpcProvider(evm) : evm;
    }
}
exports.ChainBase = ChainBase;
/**
 * Default EVM provider URLs
 */
ChainBase.DEFAULT_EVM_RPC = {
    [protocol_1.ChainId.EthereumMainnet]: 'https://mainnet.infura.io/v3/0ad93f38d5e048a19b715f15c3bbaf5e',
    [protocol_1.ChainId.EthereumGoerli]: 'https://goerli.infura.io/v3/0ad93f38d5e048a19b715f15c3bbaf5e',
};
/**
 * EVM to Starknet chain ID mappings
 */
ChainBase.EVM_TO_DEFAULT_STARKNET_RPC = {
    [protocol_1.ChainId.EthereumMainnet]: 'https://starknet-mainnet.infura.io/v3/054a6e9257a94a9d91cdcbbdf3f7c1c6',
    [protocol_1.ChainId.EthereumGoerli]: 'https://starknet-goerli.infura.io/v3/054a6e9257a94a9d91cdcbbdf3f7c1c6',
};
